import { createReducer, on } from '@ngrx/store';
import { User, Merchant } from '@print2go/types';
import {
  loadUser,
  loadUserSuccess,
  loadUserFailure,
  logoutUser,
  updateUser,
  setAuthState,
} from '../actions/user.actions';

export interface UserState {
  user: Merchant | null;
  error: any;
}

export const initialState: UserState = {
  user: null,
  error: null,
};

export const userReducer = createReducer(
  initialState,
  on(setAuthState, (state, data): UserState => {
    const user = data.user as User | null;
    return { ...state, user };
  }),
  on(loadUser, (state, _): UserState => {
    return { ...state };
  }),
  on(loadUserSuccess, (state, { user }): UserState => {
    return { ...state, user: { ...state.user, ...user } };
  }),
  on(loadUserFailure, (state, { error }): UserState => {
    return { ...state, error };
  }),
  on(logoutUser, (_): UserState  => {
    return { ...initialState };
  }),
  on(updateUser, (state, { data }): UserState => {
    const { uid, ...userUpdates } = data;
    if (!state.user) throw new Error('User in store is null');
    if (state.user.uid !== uid) throw new Error(`User in store (${state.user.uid}) does not match user id (${uid})`);

    const userBefore = state.user;
    const user = {...userBefore, ...userUpdates};
    return {...state, user };
  })
);